// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AccountAppSchema } from './v1/accountAppSchema';

export const listAccountAppsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const listAccountAppsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description List of connected apps
 */
export const listAccountApps200Schema = z.array(z.lazy(() => v1AccountAppSchema));

export const listAccountAppsQueryResponseSchema = z.lazy(() => listAccountApps200Schema);
